import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';
import UnidadeEdit from '../paginas/unidade-medida/edit';

@autobind
class UnidadeMedida extends React.Component {
  render() {
    return <Lookup labelKey="descricao" valueKey="id" url="/UnidadeMedidaLookup" editComponent={UnidadeEdit} {...this.props} />;
  }
}

export default UnidadeMedida;
